import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SystemOverview } from './components/SystemOverview';
import { WhatIncludes } from './components/WhatIncludes';
import { Bonuses } from './components/Bonuses';
import { ForYouIf } from './components/ForYouIf';
import { Results } from './components/Results';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const fbq = function (...args: any[]) {
        if ((fbq as any).callMethod) {
          ;
          (fbq as any).callMethod.apply(fbq, args);
        } else {
          ;
          (fbq as any).queue.push(args);
        }
      };
      (fbq as any).push = fbq;
      (fbq as any).loaded = true;
      (fbq as any).version = '2.0';
      (fbq as any).queue = [];
      (window as any).fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      fbq('init', '26257470350562748');
      fbq('track', 'PageView');
    }
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('oferta-reloj') || document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="w-full min-h-screen bg-[#faf9f7]" data-id="element-0">
      <Hero onCTAClick={scrollToPurchase} data-id="element-1" />
      <SystemOverview data-id="element-2" />
      <WhatIncludes onCTAClick={scrollToPurchase} data-id="element-3" />
      <Bonuses data-id="element-4" />
      <ForYouIf data-id="element-5" />
      <Results data-id="element-6" />
      <Pricing data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}